import { useState } from "react"

import { Grid, List } from "lucide-react"

import { ToggleGroup, ToggleGroupItem } from "@ui/toggle-group"
import { LAST_DISPLAYED_VIEW } from "@/constants/cookies"

interface ContentDispositionButtonProps {
    onUpdate: (value: boolean) => void
}
export function ContentDispositionButton({ onUpdate }: Readonly<ContentDispositionButtonProps>) {
    const [view, setView] = useState(localStorage.getItem(LAST_DISPLAYED_VIEW) === "grid" ? "grid" : "list")

    const updateView = (value: string) => {
        const result = value === "grid" ? "grid" : "list"
        localStorage.setItem(LAST_DISPLAYED_VIEW, result)
        setView(result)
        onUpdate(value === "grid")
    }

    return (
        <ToggleGroup type="single" value={view} onValueChange={(value) => updateView(value)} className='bg-white border border-gray-400 rounded-sm'>
            <ToggleGroupItem value="grid">
                <Grid />
            </ToggleGroupItem>
            <ToggleGroupItem value="list">
                <List />
            </ToggleGroupItem>
        </ToggleGroup>
    );
}